import React, { useState } from "react";
import CancelTradeModal from "features/trades/CancelTrade/CancelTradeModal";

interface CancelTradeProps {
  trigger: React.JSX.Element;
  tradeId: number;
  showCloseOptions: boolean;
  onClick?: () => void;
  accountIsValid?: boolean;
  symbol?: string;
  accountId?: number;
}

// Passing props through to trigger component is required for antd trigger components to work properly
// (for example, MenuItem)
const CancelTradeTrigger = ({
  trigger,
  tradeId,
  showCloseOptions,
  accountIsValid,
  symbol,
  accountId,
  ...props
}: CancelTradeProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div>
      {React.cloneElement(trigger, {
        ...props,
        onClick: () => {
          setModalOpen(true);
        },
      })}
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <CancelTradeModal
          isVisible={modalOpen}
          tradeId={tradeId}
          closeModal={() => setModalOpen(false)}
          showCloseOptions={showCloseOptions}
          accountIsValid={accountIsValid}
          symbol={symbol}
          accountId={accountId}
        />
      </div>
    </div>
  );
};

export default CancelTradeTrigger;
